// Sources route (/ops/sources): the selected family in the URL; the screen is SourcesPage.
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { optionalString } from "@/app/search";
import { SourcesPage } from "@/features/operations/SourcesPage";

const searchSchema = z.object({
  family: optionalString(),
});

export const Route = createFileRoute("/_app/ops/sources")({
  validateSearch: searchSchema,
  staticData: { crumb: "Sources" },
  component: SourcesPage,
});
